import { useDrop } from "react-dnd"
import "./iukdrop.css"
import { ItemTypes } from "../../ItemTypes"

export default function IukDrop() {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept : ItemTypes.MISSION,
    //drop: onDrop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })
  return (
    <div className="iukdrop">
      <div className="iukdroplist">
        <div className="iukdropitem" ref={drop}>
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            {isOver?
            	'10 - Borkum -> neu' :
              '10 - Borkum'
            }
            
          </div>
        </div>
        <div className="iukdropitem">
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            	11 - Hesel
          </div>
        </div>
        <div className="iukdropitem">
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            	12 - Jümme
          </div>
        </div>
        <div className="iukdropitem">
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            	13 - Leer
          </div>
        </div>
        <div className="iukdropitem">
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            	14 - Moormerland
          </div>
        </div>
        <div className="iukdropitem">
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            	15 - Uplengen
          </div>
        </div>
        <div className="iukdropitem">
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            	20 - Bunde
          </div>
        </div>
        <div className="iukdropitem">
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            	21 - 
          </div>
        </div>
        <div className="iukdropitem">
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            	22 - 
          </div>
        </div>
        <div className="iukdropitem">
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            	23 - 
          </div>
        </div>
        <div className="iukdropitem">
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            	24 - 
          </div>
        </div>
        <div className="iukdropitem">
          <div className="iukdropitemImg"></div>
          <div className="iukdropitemName">
            	25 - Westoverledingen
          </div>
        </div>
      </div>
    </div>
  )
}
